// Module
var code = "<div class=\"tabulator-footer\"> <div class=\"message pull-left\"> <span>{{ $ctrl.table.loading ? ('common.loading' | translate) : $ctrl.message }}</span> <span class=\"custom-error\" ng-show=\"customError && !$ctrl.disabled\"> — {{ customError }}</span> </div> </div> ";
// Exports
export default code;